import React, { ReactElement } from "react";

function Work(): ReactElement {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
            <path d="M2.021 30h27.621V12.333H2.021V30zM0 10.333h31.663V32H0V10.333zm10.105-5h11.453v2H10.105v-2z"></path>
        </svg>
    );
}

export default Work;
